import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Delivery, DeliveryStatus, DeliveryStatusAux } from 'src/app/models/delivery.schema';
import { Product } from 'src/app/models/product.schema';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { CustomPaymentsService } from 'src/app/services/custom-payments.service';


@Component({
  selector: 'app-delivery-monitoring',
  templateUrl: './delivery-monitoring.component.html',
  styleUrls: ['./delivery-monitoring.component.scss'],
})

export class DeliveryMonitoringComponent implements OnInit {

  delivery: Delivery;
  currentStatus: string;
  isNotDelivered: boolean = false;
  statuses: string[] = [];
  steps: any[] = [];
  currentStepIndex: number = 0; 
  showingCurrentStatus: string;
  subtotal: number = 0;
  totalPrice: number = 0;
  shippingPrice: number = 0;
  taxPrice: number = 0;
  orderedStatuses = [
    'created',
    'assigned',
    'delivering',
    'delivered',
    'notdelivered',
    'canceled',
  ];

  constructor(
    private route: ActivatedRoute,
    private commanUsesService: CommanUsesService,
    private customPaymentsService: CustomPaymentsService,
  ) { }

  async ngOnInit() {
    try {
      const deliveryId: string = this.route.snapshot.paramMap.get('id');
      if(deliveryId) {
        this.delivery = await this.customPaymentsService.findDelivery(deliveryId);
        // console.log("this.delivery", this.delivery)
        this.maintainSaleStatus();
        this.maintainTotals();
      }
    } catch (error) {
      
    }
  }

  async maintainSaleStatus() {
    try {

      const deliveriesArray = [];
      deliveriesArray.push(this.delivery);

      const deliveries: Delivery[] = deliveriesArray || [];

      if (!deliveries.length) {
        this.currentStatus = DeliveryStatus.created.toLowerCase();
        return;
      }

      const orderedStatuses = [
        DeliveryStatus.created.toLowerCase(),
        DeliveryStatus.accepted.toLowerCase(),
        DeliveryStatus.assigned.toLowerCase(),
        DeliveryStatus.delivering.toLowerCase(),
        DeliveryStatus.delivered.toLowerCase(),
        DeliveryStatus.notDelivered.toLowerCase(),
        DeliveryStatus.canceled.toLowerCase(),
      ];

      const allStatuses = deliveries
        .map((d: any) => d.status?.toLowerCase())
        .filter((s: string) => orderedStatuses.includes(s));

      if (!allStatuses.length) {
        this.currentStatus = DeliveryStatus.created.toLowerCase();
        return;
      }

      let minIndex = orderedStatuses.length;

      allStatuses.forEach((status: string) => {
        const index = orderedStatuses.indexOf(status);

        const effectiveIndex =
          status === DeliveryStatus.accepted.toLowerCase()
            ? orderedStatuses.indexOf(DeliveryStatus.created.toLowerCase())
            : index;

        if (effectiveIndex !== -1 && effectiveIndex < minIndex) {
          minIndex = effectiveIndex;
        }
      });

      this.currentStatus = orderedStatuses[minIndex];
      this.showingCurrentStatus = DeliveryStatusAux.trackingAux[this.currentStatus]?.ln?.it || '';

      this.statuses = this.getStatuses(deliveries);
      this.isNotDelivered = this.checkIfNotDelivered();
      this.steps = this.getSteps();

      const currentStep = this.steps.find(step => step.status === this.currentStatus);
      let targetIndex = currentStep ? this.steps.indexOf(currentStep) + 1 : 0;

      if (currentStep?.status === 'created' && targetIndex < this.steps.length) {
        targetIndex++;
      }

      if (targetIndex > 0) {
        this.currentStepIndex = 0;
        setTimeout(() => this.animateStatusChange(targetIndex), 50);
      } else {
        this.currentStepIndex = 0;
      }
    } catch (error) {
      console.error('Error maintaining sale status:', error);
    }
  }

  getStatuses(deliveries: any[]): string[] {
    return deliveries
      .map(d => d.status?.toLowerCase())
      .filter(status => this.orderedStatuses.includes(status)) || [];
  }

  getSteps(): any[] {
    let baseSteps = [
      { label: 'Ordine confermato', icon: 'fas fa-check-circle', status: 'created' },
      { label: 'In creazione dall’Artista', icon: 'fas fa-truck-pickup', status: 'assigned' },
      { label: 'Sulla strada', icon: 'fas fa-shipping-fast', status: 'delivering' },
    ];

    if (this.currentStatus !== 'canceled') {
      if (this.isNotDelivered) {
        baseSteps.push({ label: 'Non Consegnato', icon: 'fas fa-times-circle', status: 'notdelivered' });
      } else {
        baseSteps.push({ label: 'Consegnato', icon: 'fas fa-box', status: 'delivered' });
      }
    }

    if (this.currentStatus === 'canceled') {
      baseSteps.push({ label: 'Annullato', icon: 'fas fa-times-circle', status: 'canceled' });
    }

    return baseSteps;
  }

  checkIfNotDelivered(): boolean {
    return this.currentStatus === DeliveryStatus.notDelivered.toLowerCase();
  }

  animateStatusChange(targetIndex: number) {
    if (this.currentStepIndex >= targetIndex) return;

    const stepDelay = 800; 
    const interval = setInterval(() => {
      this.currentStepIndex++;

      if (this.currentStepIndex >= targetIndex) {
        clearInterval(interval);
      }
    }, stepDelay);
  }

  isStepActive(index: number): boolean {
    return index < this.currentStepIndex;
  }

  isStepNotDelivered(index: number): boolean {
    return (index < this.currentStepIndex && (this.isNotDelivered || this.currentStatus === 'canceled'));
  }

  async maintainTotals() {
    try {
      this.subtotal = 0;

      this.delivery.deliveryProducts.forEach((item) => {
        // console.log("item", item);
        const product: Product = item?.product || {};
        const variant = item?.productVariant || null;

        const unitPrice = variant?.variantPrice
          ? Number(variant.variantPrice)
          : Number(product.price || '0');

        const quantity = Number(item.quantity || 1);
        const validQuantity = isNaN(quantity) || quantity <= 0 ? 1 : quantity;

        const validPrice = isNaN(unitPrice) || unitPrice <= 0 ? 0 : unitPrice;

        this.subtotal += validPrice * validQuantity;
      });

      this.totalPrice = this.subtotal + (Number(this.shippingPrice) || 0) + (Number(this.taxPrice) || 0);

    } catch (error) {
      console.error('Error maintainTotals:', error);
    }
  }


}
